import { CloseIcon1, TransparentDeleteIcon } from 'assets/icons';
import ArrowIconThick from 'assets/images/arrows/arrowIconThick.svg?react';
import cn from 'classnames';
import { GamesState } from 'features/eventPreMatch/interface/sportPrematch';
import { t } from 'i18next';
import Button from 'shared/components/form/button';
import './styles.scss';

interface BetbuilderOverviewDesktopProps {
	totalOdds: number;
	onAddBetToCoupon: () => void;
	selectedOddsArray: GamesState[];
	handleClick: () => void;
	isShowSelectedBets: boolean;
	onClickRemoveGame: (elem: number) => void;
	clickOnCross: () => void;
	getSelectedOutcomeName: any;
}

const BetbuilderOverviewDesktop = ({
	totalOdds,
	onAddBetToCoupon,
	selectedOddsArray,
	handleClick,
	isShowSelectedBets,
	onClickRemoveGame,
	clickOnCross,
	getSelectedOutcomeName,
}: BetbuilderOverviewDesktopProps) => {
	const isMoreThenOneBetbuilderEvent = selectedOddsArray.length > 1;
	const renderText = isShowSelectedBets ? t('collapse') : t('expand');

	return (
		<div className="BetbuilderOverviewDesktop__wrapper">
			<div className="BetbuilderOverviewDesktop__header">
				<div className="BetbuilderOverviewDesktop__oddsArray" aria-controls="fade-menu">
					<div className="BetbuilderOverviewDesktop__title">
						{t('betBuilder')} ({selectedOddsArray.length})
						{isMoreThenOneBetbuilderEvent && <div>{totalOdds < 0 ? Number(0).toFixed(2) : totalOdds.toFixed(2)}</div>}
					</div>
					{selectedOddsArray.length === 1 && <span className="BetbuilderOverviewDesktop__text">{t('betBuilderAddEventText')}</span>}
					{isMoreThenOneBetbuilderEvent && (
						<div className="BetbuilderOverviewDesktop__actions">
							<div className="BetbuilderOverviewDesktop__toggle" onClick={handleClick}>
								<ArrowIconThick
									className={cn('BetbuilderOverviewDesktop__dropdown__icon', {
										'BetbuilderOverviewDesktop__dropdown__icon--rotated': !isShowSelectedBets,
									})}
								/>
								<span className="BetbuilderOverviewDesktop__expandStatus">{renderText}</span>
							</div>
							<Button
								btnType="secondary"
								btnHeight="small"
								onClick={() => onAddBetToCoupon()}
								disabled={totalOdds <= 0}
								cyTestRef="betbuilder-add"
								className="BetbuilderOverviewDesktop__button"
							>
								{t('addToCoupan')}
							</Button>

							<div className="BetbuilderOverviewDesktop__deleteAll" data-cy="betbuilder-delete" onClick={clickOnCross}>
								<TransparentDeleteIcon />
							</div>
						</div>
					)}
				</div>
			</div>

			{isMoreThenOneBetbuilderEvent && isShowSelectedBets && (
				<>
					{selectedOddsArray.map((item, index) => (
						<div className="BetbuilderOverviewDesktop__eventDetail" key={`selectedOddsArray-${index}`}>
							<div className="BetbuilderOverviewDesktop__eventDetailBody">
								<p className="BetbuilderOverviewDesktop__gameName">{item.gameName}</p>
								<p className="BetbuilderOverviewDesktop__outcomeName">{getSelectedOutcomeName(item)}</p>
							</div>
							<CloseIcon1 className="BetbuilderOverviewDesktop__closeIcon" onClick={() => onClickRemoveGame(item.outcomeId)} />
						</div>
					))}
				</>
			)}
		</div>
	);
};

export default BetbuilderOverviewDesktop;
